/**
 * Frontend JavaScript for Video Text Block
 * Handles video autoplay and performance optimization
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all video elements in video-text-block
  const videoBlocks = document.querySelectorAll('.wp-block-mitery-blocks-video-text-block video');
  
  if (videoBlocks.length === 0) return;

  // Create intersection observer for performance
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      
      if (entry.isIntersecting) {
        // Video is visible, ensure it's playing
        if (video.paused && video.autoplay) {
          video.play().catch(error => {
            // Check specifically for NotAllowedError due to no user interaction
            if (error.name === 'NotAllowedError') {
              console.log('Video autoplay blocked - waiting for user interaction');

              const isMuted = video.muted;
              console.log('isMuted', isMuted);
              if (!isMuted) {
                video.muted = true;
                video.play().catch(e => console.log('Video playback failed:', e));

                document.addEventListener('click', () => {
                  if (video.muted) {
                    // Restart video from beginning when unmuting
                    video.currentTime = 0;
                    video.play().catch(e => console.log('Video playback failed after unmuting:', e));
                    video.muted = false;
                  }
                });
              }
            } else {
              console.log('Video autoplay failed:', error);
            }
          });
        }
      } else {
        // Video is not visible, pause it to save resources
        if (!video.paused) {
          video.pause();
        }
      }
    });
  }, {
    threshold: 0.1, // Trigger when 10% of video is visible
    rootMargin: '50px' // Start loading 50px before video comes into view
  });

  // Observe all videos
  videoBlocks.forEach(video => {
    // Set video attributes for better performance
    video.setAttribute('preload', 'metadata');
    video.setAttribute('playsinline', '');
    
    // Add to intersection observer
    videoObserver.observe(video);
    
    // Handle video loading
    video.addEventListener('loadedmetadata', function() {
      // Video metadata loaded, ready to play
      if (video.autoplay && !video.paused) {
        video.play().catch(error => {
          // Check for NotAllowedError on initial load
          if (error.name === 'NotAllowedError') {
            console.log('Initial autoplay blocked - waiting for user interaction');
          } else {
            console.log('Video autoplay failed after metadata load:', error);
          }
        });
      }
    });
    
    // Handle video errors
    video.addEventListener('error', function(e) {
      console.error('Video error:', e);
    });
  });
});
